import { DashboardMetricCategory } from '@liquitics/transaction';
export type DashboardGraphicalChartType = 'DefaultLine' | 'CompareLine' | 'TimeLine' | 'CompareTimeLine' | 'TrendLine' | 'DefaultPie' | 'DefaultScatterPlot' | 'DefaultColumn' | 'TimeColumn' | 'CompareTimeColumn' | 'DefaultStackedColumn' | 'TimeStackedColumn' | 'DefaultDonut' | 'Custom';
export class DashboardGraphicalConfig {
    constructor(public code: string, public category: DashboardMetricCategory, public label: string, public chartType: DashboardGraphicalChartType, public subCategory?: string, public amountFields?: any[]) {
    }
}
